<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>CSI Official App</title>

      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
    </head>

    <header @mousedown="handleonmousedown($event)">
      <div class="header_div">
        <div class="header_div_top">
          <div class="header_div_top_logo">
            <img src="./images/logo2.png" />
          </div>
          <div class="header_div_top_nine"><img src="./images/icon.png" /></div>
        </div>
        <div class="header_div_con">
          <div class="header_div_con_top">
            Bringing <br />Global Business<br />
            Into Focus
          </div>
          <div class="header_div_con_bottom">
            Search 500+ million companies in 200+<br />
            countries and territories
          </div>
        </div>

        <div class="header_div_bottom">
          <div class="header_div_bottom_div">
            <input
              class="header_div_bottom_input"
              :placeholder="$t('MyDatabase.Entercompanyname')"
            />
            <div class="header_div_bottom_icon">
              <img src="./images/icon1.png" />
            </div>
          </div>
          <div class="header_div_bottom_div_bottom">
            <div class="header_div_bottom_div_bottom_div">
              <form>
                <input
                  type="radio"
                  class="header_div_bottom_div_bottom_div_txt"
                  value="Keyword"
                  checked
                />Keyword
                <input
                  type="radio"
                  class="header_div_bottom_div_bottom_div_txt"
                  value="Left Partial"
                />Left Partial
              </form>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="csiPhone-bottom">
      <div>
        <swiper :options="swiperOption" class="swiper-container">
          <swiper-slide>
            <div class="section_div">
              <div class="section_div_div2">
                <div class="section_div_div2_top">
                  <div class="section_div_div2_top_img">
                    <img src="../../assets/img/WechatIMG290.jpg" />
                  </div>
                </div>
                <div class="section_div_div2_txt">
                  To quickly search, view, and obtain <br />company information,
                  you can also use the <br />CSI App on your phone.
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="section_div">
              <!-- <div class="section_div_div"> -->
              <swiperventer></swiperventer>
              <!-- </div> -->
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="section_div">
              <div class="section_div_div1">
                CSI, a data-driven research and IT firm, specializes in credit,
                risk, and big data. It offers digital tools to global investors
                and business professionals, leveraging advanced analytics and
                algorithms to provide fast, visual insights that facilitate
                smarter decision-making.
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>
<script>
import swiperventer from "./component/swiperVenter.vue";

export default {
  mounted() {},
  data() {
    return {
      swiperOption: {
        //居中幻灯片无缺口。当你通过设置 centeredSlides: true 使得幻灯片居中后，
        paginationClickable: true,
        // 挂载指示点
        // pagination: '.swiper-pagination',
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
          clickable: true,
        },
        // 左右箭头
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // }
      },
    };
  },
  components: {
    swiperventer,
  },
  methods: {
    handleonmousedown(e) {
      this.$message({
        message: "Please open it on the computer",
        center: true,
        type: "success",
      });
    },
    // getswipert() {
    //   this.swipertwo = new Swiper(".swiper-container", {

    //

    //     pagination: '.swiper-pagination',
    //   });
    // },
  },
};
</script>
<style scoped>
.csiPhone-bottom {
  height: calc(100% - 29.0625rem);
  background-color: #f2f2f2;
}
body {
  width: 100%;
  height: 100%;
  max-width: 100%;
  min-width: 375px;
  margin: auto;
  font-size: 100%;
  font-size: 16px;
  font-size: 1em;
  background-color: #f2f2f2;
}

img:not([src*="/"]) {
  display: none;
}

img {
  max-width: 100%;
  height: auto;
}

a img {
  border: 0;
}

li,
ol {
  list-style: none;
}

header {
  width: 100%;
  height: auto;
}

.header_div {
  width: 100%;
  min-height: 29.0625rem;
  background-image: url("./images/bg.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 100%;
}

.header_div_top {
  /* width: 90%; */
  /* height: 1.875rem; */
  margin-bottom: 0.9375rem;
  padding-top: 1.25rem;
  padding-bottom: 0.9375rem;
  padding-left: 5%;
  padding-right: 5%;
  /* overflow: hidden; */
  display: flex;
  justify-content: space-between;
}

.header_div_top_logo {
  /* float: left; */
  width: 11.5625rem;
  height: 1.875rem;
}
/deep/ .swiper-pagination-bullets-dynamic {
  height: 20px !important;
}
/deep/.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transform: none !important;
  margin: 0 5px;
  position: static !important;
}
.header_div_top_nine {
  /* float: right; */
  width: 1.875rem;
  height: 1.875rem;
}

.header_div_con {
  /* width: 84%; */
  height: auto;
  margin-bottom: 3.125rem;
  padding-left: 8%;
  padding-right: 8%;
}

.header_div_con_top {
  width: 100%;
  height: auto;
  line-height: 3.5rem;
  margin-bottom: 0.625rem;
  font-family: "Arial-Bold";
  font-size: 2.5rem;
  font-weight: bold;
  color: #ffffff;
}

.header_div_con_bottom {
  width: 100%;
  height: auto;
  line-height: 1.625rem;
  font-family: "Arial-Regular";
  font-size: 1rem;
  color: #ffffff;
}

.header_div_bottom {
  width: 100%;
  height: auto;
  padding-left: 5%;
  padding-right: 5%;
}

.header_div_bottom_div {
  /* width: 86%; */
  /* height: 1.5rem; */
  margin-bottom: 0.9375rem;
  padding-top: 0.8125rem;
  padding-bottom: 0.8125rem;
  padding-left: 6%;
  padding-right: 6%;
  background-color: #ffffff;
  border-radius: 1.5625rem;
  overflow: hidden;
}

.header_div_bottom_input {
  float: left;
  width: 85%;
  height: 1.5rem;
  border: 0;
  background-color: transparent;
  font-family: "Arial-Regular";
  font-size: 1.125rem;
  color: #999999;
}

.header_div_bottom_icon {
  float: right;
  width: 1.5rem;
  height: 1.5rem;
}

.header_div_bottom_div_bottom {
  width: 100%;
  height: 1.25rem;
}

.header_div_bottom_div_bottom_div {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 1.25rem;
  line-height: 1.25rem;
  margin: 0 auto;
  font-family: "Arial-Regular";
  font-size: 1rem;
  color: #ffffff;
}

.header_div_bottom_div_bottom_div_txt {
  appearance: none;
  outline: none;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background-color: white;
  position: relative;
  margin: 0 10px;
  border: 1px solid #d2d2d2;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid #1290c9;
}

.header_div_bottom_div_bottom_div_txt:checked {
  width: 1.25rem;
  height: 1.25rem;
  border: 1px solid #1290c9;
  z-index: 2;
}

.header_div_bottom_div_bottom_div_txt:checked::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background-color: #1290c9;
  z-index: 1;
}

section {
  width: 100%;
  height: auto;
}

.swiper-container {
  width: 100%;
  height: auto;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  background-color: #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-wrapper {
  width: 100%;
  height: auto;
  margin-bottom: 1.25rem;
}

.swiper-slide {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

/deep/ .swiper-pagination-bullet-active {
  width: 1.5625rem !important;
  border-radius: 0.25rem !important;
}
/deep/ .swiper-pagination-bullets-dynamic {
  width: 100% !important;
  /* overflow: hidden; */
  /* font-size: 7px; */
  height: auto;
  display: flex;
  justify-content: center;
  background-color: #f2f2f2;
  /* align-items: center; */
}
.section_div {
  width: 100%;
  height: 17.875rem;
  padding-left: 3%;
  padding-right: 3%;
}

.section_div_div {
  width: 100%;
  height: 17.875rem;
  background-color: #1290c9;
  border-radius: 1.25rem;
}

.section_div_div1 {
  height: 100%;
  /* width: 94%; */
  /* height: 14.0625rem; */
  line-height: 1.625rem;
  padding-top: 2.8125rem;
  padding-bottom: 3%;
  padding-left: 3%;
  padding-right: 3%;
  background-image: url("./images/bg1.png");
  background-position: top center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 1.25rem;
  font-family: "Arial-Regular";
  font-size: 1rem;
  color: #ffffff;
  box-shadow: 0px 0px 10px 0 rgb(0, 0, 0, 0.3);
}

.section_div_div2 {
  height: 100%;
  /* width: 92%; */
  /* height: 15.625rem; */
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  padding-left: 4%;
  padding-right: 4%;
  background-color: #ffffff;
  border-radius: 1.25rem;
  box-shadow: 0px 0px 10px 0 rgb(153, 153, 153, 0.1);
}

.section_div_div2_top {
  width: 100%;
  height: 8.75rem;
  margin-bottom: 0.9375rem;
}

.section_div_div2_top_img {
  width: 8.75rem;
  height: 8.75rem;
  margin: 0 auto;
  box-shadow: 0px 0px 10px 0 rgb(136, 136, 136, 0.3);
}

.section_div_div2_txt {
  width: 100%;
  height: auto;
  line-height: 1.625rem;
  font-family: "Arial-Regular";
  font-size: 1.0625rem;
  color: #000000;
  text-align: center;
}

footer {
  width: 100%;
  height: 1.25rem;
}
</style>
